export default __webpack_public_path__ + "static/media/logo.3537e186.svg";